import styled from "styled-components";

export const CustomerReviewCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 12px;
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.default[50]};
  height: fit-content;
  width: 100%;

  ${({ theme }) => theme.breakpoints.lg.query} {
    width: 100%;
  }
`;

export const CustomerRating = styled.div`
  display: flex;
  align-items: center;
`;

export const CustomerRatingNumber = styled.div`
  margin-left: 4px;
  margin-top: 4px;
  color: ${({ theme }) => theme.colors.default[900]};
  font-size: 14px;
  font-style: normal;
  font-weight: 900;
  line-height: 150%; /* 21px */
`;

export const CustomerReview = styled.div`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.default[500]};
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 25.5px */
  letter-spacing: 0.017px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
`;
